// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
export const GemsApiCertificateFragmentDoc = gql`
    fragment gemsApiCertificate on GemsApi_Stone {
  certificates {
    gcal
    gia
    igi
  }
}
    `;